let selected = null;

$(function () {
  $(document).on("click", ".collapsible-item .show-details", onToggleCollapse);
  $(document).on("click", ".email_selectable", onSelectedEmail);
});

const storageKey = "digiformaEmailCollapsible";
onTriggeredCollapse();

function onToggleCollapse(e) {
  e.preventDefault();
  e.stopPropagation();
  const url = window.location.href;
  if (url.includes("training_sessions/")) {
    const trainingSessionId = url.split("training_sessions/")[1].split("/")[0];
    let digiStorage = JSON.parse(localStorage.getItem(storageKey));
    if (digiStorage && digiStorage[trainingSessionId]) {
      delete digiStorage[trainingSessionId];
      localStorage.setItem(storageKey, JSON.stringify(digiStorage));
    }
  }

  let $collapsibleItem = $(this).closest(".collapsible-item");
  let id = $collapsibleItem.data("collapsible-id");
  $(".collapsible-item").removeClass("selected");
  if (selected == id) {
    selected = null;
    $collapsibleItem.trigger("collapsible-item:close");
  } else {
    selected = id;
    $collapsibleItem.addClass("selected");
    $collapsibleItem.trigger("collapsible-item:select");
  }
}

function onSelectedEmail(e) {
  e.preventDefault();
  e.stopPropagation();

  const trainingSessionId = this.getAttribute("ts_id");
  const email_id = this.getAttribute("email_id");
  let digiStorage = JSON.parse(localStorage.getItem(storageKey));
  if (!digiStorage) {
    digiStorage = { [trainingSessionId]: email_id };
  } else {
    if (digiStorage[trainingSessionId] === email_id) delete digiStorage[trainingSessionId];
    else Object.assign(digiStorage, { [trainingSessionId]: email_id });
  }
  localStorage.setItem(storageKey, JSON.stringify(digiStorage));
  const route = `/training_sessions/${trainingSessionId}/communications`;
  window.location.href = route;
}

// Restore the visibility of the registered collapsible email.
function onTriggeredCollapse() {
  const url = window.location.href;

  if (!url.includes("/communications")) return;

  const trainingSessionId = url.split("training_sessions/")[1].split("/")[0];
  const digiStorage = JSON.parse(localStorage.getItem(storageKey));
  const openId = digiStorage && digiStorage[trainingSessionId];

  if (openId) {
    localStorage.setItem(storageKey, JSON.stringify(digiStorage));
    let $collapsibleItem = $(document.getElementById(`${openId}`)).closest(".collapsible-item");
    $collapsibleItem.addClass("selected");
    $collapsibleItem.trigger("collapsible-item:select");
  }
}
